import React, { useState } from 'react';
import Footer from '../JobPage/Footer';
import Header from '../JobPage/Header';
import { CategoryTabs } from './CategoryTab';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';
import { Inline } from '@/Components/ui/layout';
import { Card, CardContent } from '@/Components/ui/card';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/Components/ui/select';
import { cn } from '@/lib/utils';

export function TopTechLocations() {
  const [selectedLocation, setSelectedLocation] = useState('');

  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col items-center justify-center py-7 px-20">
      <Container size="default" className="w-full max-w-[1214px]">
        <Header />
        <CategoryTabs />
        
        <div className="flex gap-5 mt-[81px]">
          <div className="w-[24%]">
            <div className="mt-[43px]">
              <Select value={selectedLocation} onValueChange={setSelectedLocation}>
                <SelectTrigger 
                  className="w-full h-auto py-2.5 px-2.5 rounded-lg border border-muted-foreground/30 bg-background text-foreground text-[25px] font-medium tracking-wide"
                  aria-label="Select location"
                >
                  <SelectValue placeholder="Select" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Locations</SelectItem>
                  <SelectItem value="us">United States</SelectItem>
                  <SelectItem value="uk">United Kingdom</SelectItem>
                  <SelectItem value="canada">Canada</SelectItem>
                  <SelectItem value="germany">Germany</SelectItem>
                  <SelectItem value="india">India</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="w-[76%] flex flex-wrap gap-[81px]">
            {[...Array(10)].map((_, index) => (
              <div key={index} className="w-[calc(50%-40.5px)] relative pt-[43px]">
                <div className={cn(
                  "absolute top-0 left-1/2 -translate-x-1/2 w-[100px] h-[100px]",
                  "rounded-full border border-muted-foreground/30 bg-background",
                  "flex items-center justify-center text-[35px] text-foreground tracking-wide z-10"
                )}>
                  {String(index + 1).padStart(2, '0')}.
                </div>
                <Card className="rounded-lg border border-muted-foreground/30 pt-[45px] pr-[45px] pb-4 pl-0">
                  <CardContent className="p-0">
                    <Inline justify="between" align="center" className="mb-[45px] text-[25px] tracking-wide">
                      <Text size="xl">City Name</Text>
                      <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/fa20a7355758f1cf4aa1e6042ad61a16ac1a665bd04d01c2b8bca8456e3889d7?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
                        alt="Location icon"
                        className="w-[50px] h-[50px]"
                      />
                    </Inline>
                    <img
                      loading="lazy"
                      src={`http://b.io/ext_${6 + index}-`}
                      alt="City statistics"
                      className="w-[175px] mt-[45px]"
                    />
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  );
}

export default TopTechLocations;
